import { FC, useState } from "react";
import { useLocation } from "react-router";
import {
  AuthenticationProviderType,
  AuthenticationProviderVarieties,
} from "@vviinn/user-managment-client-ts";

import { AuthForm } from "../wrappers";
import { generalAuthSteps, handleResetStep } from "../general";
import { useApi } from "../../api";
import {
  useAppDispatch,
  authentificate,
  getAuthenticationProviders,
} from "../../store";
import { DEFAULT_ERROR_WITH_SUGGESTION_MESSAGE } from "../../ui/constants";

type ErrorMessagesKeys =
  | "default"
  | "auth/user-not-found"
  | "auth/wrong-password";

const errorMessages: Record<ErrorMessagesKeys, string> = {
  default: DEFAULT_ERROR_WITH_SUGGESTION_MESSAGE,
  "auth/user-not-found": "User not found",
  "auth/wrong-password": "Wrong Password",
};

export const LoginForm: FC<React.PropsWithChildren> = () => {
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState<string>(
    location.state?.errorMessage ?? "",
  );
  const dispatch = useAppDispatch();
  const { getAnonymousApi } = useApi();

  const handleLogin = async (
    email?: string,
    password?: string,
    providerId?: string,
    providerType?: AuthenticationProviderType,
  ) => {
    const authData = { email, password, providerId, providerType };
    const loginResult = await dispatch(authentificate(authData));
    if ("error" in loginResult) {
      let errorMessageCode: ErrorMessagesKeys = loginResult.error
        .code as ErrorMessagesKeys;
      if (!errorMessages[errorMessageCode]) {
        errorMessageCode = "default";
      }

      setErrorMessage(errorMessages[errorMessageCode]);
    } else {
      generalAuthSteps.map(handleResetStep);
    }
  };

  const getConfigs = async (
    email: string,
    recaptchaToken: string,
  ): Promise<AuthenticationProviderVarieties> => {
    const api = await getAnonymousApi();
    const value = { email, recaptchaToken };
    const result = await dispatch(
      await getAuthenticationProviders({ api, value }),
    );
    const data = result.payload as AuthenticationProviderVarieties[];
    return data[0];
  };

  return (
    <AuthForm
      submitTitle="Sign In"
      loginSubmitCallback={handleLogin}
      getConfigs={getConfigs}
      errorMessage={errorMessage}
      setErrorMessage={setErrorMessage}
      steps={generalAuthSteps}
    />
  );
};
